export default function() {
  //get the search field
  const search_field = document.getElementById('countrySearch');
  //get the country hotline name elements
  const country_hotlines = document.querySelectorAll('.country_lt');

  //check if fields exist so we don't throw a null error
  if(search_field && country_hotlines) {
    search_field.addEventListener('input', function() {
      country_hotlines.forEach((country_hotline) => {
        //set all country hotline numbers to hidden
        country_hotline.parentElement.parentElement.style.display = 'none';
        //set everything to lower case for a better search experience
        let country_hotline_text = country_hotline.innerText.toLowerCase();
        let search_value = this.value.toLowerCase();
        //show hotlines that match search
        if(country_hotline_text.includes(search_value)) {
          country_hotline.parentElement.parentElement.style.display = 'block';
        }
      });
    });
  }
}